//
//  SDKWorkspaceSubscriptionProduct.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Workspace subscription product enum
export var WorkspaceSubscriptionProductCode;
(function (WorkspaceSubscriptionProductCode) {
    /** The workspace is on free tier */
    WorkspaceSubscriptionProductCode["free"] = "free";
    /** The workspace is on team tier */
    WorkspaceSubscriptionProductCode["team"] = "team";
    /** The workspace is on team test tier */
    WorkspaceSubscriptionProductCode["teamTest"] = "team_test";
    /** The workspace is on company tier */
    WorkspaceSubscriptionProductCode["company"] = "company";
    /** The workspace is on enterprise tier */
    WorkspaceSubscriptionProductCode["enterprise"] = "enterprise";
})(WorkspaceSubscriptionProductCode || (WorkspaceSubscriptionProductCode = {}));
